module.exports = __webpack_public_path__ + "img/features-3.ac3744b.png";